import { Button, Tooltip } from "antd";
import { RightCircleOutlined } from "@ant-design/icons";
import { forwardRef, useEffect } from "react";
import { useSelector } from "react-redux";
import i18next from "i18next";

import { views_state } from "../../../features/views/viewsSlice";

const ButtonPostView = forwardRef(({ view, setMapView, currentView, setCurrentView }, ref) => {

    const viewsState = useSelector(views_state);

    useEffect(() => {
        //console.log('view', view)
        //console.log('ref', ref.current)
        view.ui.add(ref.current, {position: 'bottom-right', index: 0})
    }, [])

    /**
     * Función que muestra la visualización en la vista posterior a la actual cuando se clica en el botón de 'Zoom Siguiente'
     */
    const onClick = () => {
        //setCurrentView(currentView+1)
        //console.log('current view', currentView)
        view.when(function () {
            if(viewsState.length > 1 && viewsState.length-1 > currentView) {
                
                //console.log('views', viewsState)
                let viewIndex = currentView +1
                let viewNow = viewsState[viewIndex]
                //console.log('view', viewNow)
                //console.log('post center',viewNow.center)
                //console.log('post scale', viewNow.scale)
                view.center = viewNow.center
                view.scale = viewNow.scale
                //console.log('post center',view.center)
                //console.log('post scale', view.scale)
                setMapView(view)
                setCurrentView(currentView+1)
            }
            console.log('currentView en post', currentView)

        })
            .catch(function (err) {
                console.error("MapView rejected:", err);
            });
    }

    return (
        <>
            <div ref={ref}>
                <Tooltip title={i18next.t('common.tools.button_post_view.name')} placement="bottomLeft">
                    <Button icon={<RightCircleOutlined />} onClick={onClick}></Button>
                </Tooltip>
            </div>
        </>

    )
})

export default ButtonPostView;